<div @fadeInAnimation class="cb-battle__top">
  <div class="cb-battle__top--buttons">
    <button class="cb-battle--back-button" [routerLink]="['/battles']">
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/ui/arrow.svg"
        [svgStyle]="{ transform: 'rotate(-90deg)' }"
      />
      Back to Battles
    </button>
    @if (battle()?.status === 'open' && player().isHost) {
    <button
      @fadeInAnimation
      class="cb-battle--cancel-button"
      (click)="handleCancelBattle()"
    >
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/ui/cross.svg"
      />
      Cancel Battle
    </button>
    }
  </div>
  <app-fairness-button
    href="/provably-fair/casebattles/{{ battle()?.id }}"
  ></app-fairness-button>
</div>
<div @fadeInAnimation class="cb-battle">
  @if (battle() && animation()) { @let currentBattle = battle()!;
  <app-cb-battle-header
    (rehostBattle)="reCreateBattle()"
    (replayBattle)="rePlayBattle()"
    [battle]="currentBattle"
    [animation]="animation()"
    [balance]="player().balance"
  />
  <div class="cb-battle__middle">
    <div class="cb-battle__middle--wrapper">
      <!--  -->
      @if (animation() === 'tie') {
      <app-cb-battle-tie
        @fadeInAnimation
        [battle]="currentBattle"
      ></app-cb-battle-tie>
      }
      <!--  -->
      @if (animation() === 'open') {
      <div
        [@fadeInAnimation]
        class="cb-battle__middle--waiting"
        [style.--columns]="currentBattle.max_participants"
      >
        @for (slot of slots(); track $index;) {
        <app-cb-battle-middle-waiting-player
          [battle]="currentBattle"
          [slot]="$index + 1"
          [balance]="player().balance"
        ></app-cb-battle-middle-waiting-player>
        }
      </div>
      }
      <!--  -->
      @if (animation() === 'running' || animation() === 'round-results') {
      <div
        [@fadeInAnimation]
        class="cb-battle__middle--spinners"
        [style.--columns]="currentBattle.max_participants"
      >
        @for (slot of slots(); track $index;) {
        <app-cb-battle-spinner-2
          [battle]="currentBattle"
          [playSound]="$first"
          [slot]="$index + 1"
        ></app-cb-battle-spinner-2>
        }
      </div>
      }
      <!--  -->
      @if (animation() === 'finished' ) {
      <div class="cb-battle__middle--finished" [@fadeInAnimation]>
        <app-cb-battle-finished
          (rehostBattle)="reCreateBattle()"
          [battle]="currentBattle"
          [balance]="player().balance"
        ></app-cb-battle-finished>
      </div>
      }
      <!--  -->
      @if (animation() === 'battle-results' || animation() === 'finished') {
      <div
        class="cb-battle__middle--results"
        [style.--columns]="currentBattle.max_participants"
        [@fadeInAnimation]
      >
        @for (slot of slots(); track $index;) {
        <app-cb-battle-middle-results-player
          [battle]="currentBattle"
          [slot]="$index + 1"
          [animation]="animation()!"
        ></app-cb-battle-middle-results-player>
        }
      </div>
      }
      <!--  -->
      @if (animation() !== 'finished' && animation() !== 'tie') {
      <div
        [@fadeInAnimation]
        class="cb-battle__middle--dividers"
        [style.--columns]="currentBattle.max_participants"
      >
        @for (spinner of slots(); track $index;) {
        <!--  -->
        @let isTeamBattle = currentBattle.type === 'team';
        <!--  -->
        <div
          class="divider vertical h-full"
          [class.hidden]="$first || (isTeamBattle && $odd)"
          [style.--cb-battle--divider-color]="battleColor()"
        ></div>
        }
      </div>
      }
      <!--  -->
      @if (animation() !== 'finished') {
      <svg-icon
        [@fadeInAnimation]
        class="cb-battle--indicator"
        [class.top]="animation() === 'tie'"
        [class.left]="animation() !== 'tie'"
        [style.--cb-battle--indicator-color]="battleColor()"
        src="assets/icons/cases/roll-indicator.svg"
      />
      <svg-icon
        [@fadeInAnimation]
        class="cb-battle--indicator"
        [class.bottom]="animation() === 'tie'"
        [class.right]="animation() !== 'tie'"
        [style.--cb-battle--indicator-color]="battleColor()"
        src="assets/icons/cases/roll-indicator.svg"
      />
      }
    </div>
  </div>
  <div class="cb-battle__bottom">
    <div
      class="cb-battle__bottom--wrapper"
      [style.--columns]="currentBattle.max_participants"
    >
      @for (slot of slots(); track $index;) {
      <app-cb-battle-player-2
        [animation]="animation()!"
        [battle]="currentBattle"
        [slot]="$index + 1"
      ></app-cb-battle-player-2>
      }
    </div>
    <div
      class="cb-battle__bottom--dividers"
      [style.--columns]="currentBattle.max_participants"
    >
      @for (spinner of slots(); track $index;) {
      <!--  -->
      @let isTeamBattle = currentBattle.type === 'team';
      <!--  -->
      <div
        class="divider vertical h-full"
        [class.hidden]="$first || (isTeamBattle && $odd)"
        [style.--cb-battle--divider-color]="battleColor()"
      ></div>
      }
    </div>
  </div>
  <div class="cb-battle__skins">
    <div
      class="cb-battle__skins--wrapper"
      [style.--columns]="currentBattle.max_participants"
    >
      @for (slot of slots(); track $index;) {
      <app-cb-battle-player-skins
        [animation]="animation()!"
        [battle]="currentBattle"
        [slot]="$index + 1"
      ></app-cb-battle-player-skins>
      }
    </div>
  </div>
  } @else {
  <div class="app-loader-animation" style="width: 100%; height: 100%">
    <img src="assets/images/core/tf2-logo.png" />
  </div>
  }
</div>
